<div class="header-component">
  <!-- Top Bar -->
  @if (!isMobile) {
  <div class="header-top">
    <div class="header__brand">
      @if (!isVirtual) {
        <a class="navbar-brand" [routerLink]="['/']">
          <img [src]="theme.logoUrl" alt="PMU Logo" height="63">
          @if (theme.slogan) {
            <span class="slogan">{{ theme.slogan| translate }}</span>
          }
        </a>
      }
    </div>
    <div class="header-actions">
      @if (showUserManagementIcon) {
      <div class="user-manager">
        <span class="product-by">{{ (theme.userManagement?.poweredByText ?? 'a_product_of') | translate }}</span>
        <img (click)="gotoUrl()" [src]="theme.userManagement?.img" [alt]="theme.userManagement?.name" class="partner-logo" height="30">
      </div>
      }
      @if (showLanguageSwitcher) {
        <ng-template [ngTemplateOutlet]="langSelect"></ng-template>
      }
      @if (!isVirtual) {
        @if (!isLoggedIn ) {
          <button (click)="navigateToLogin()" type="button" class="btn-fill-primary" style="cursor: pointer;">{{ 'login' | translate }}</button>
          <button (click)="navigateToSignup()" type="button" class="btn-fill-secondary" style="cursor: pointer;">{{ 'signup' | translate }}</button>
        } @else {
          <ng-template [ngTemplateOutlet]="userActions"></ng-template>
        }
      }
    </div>
  </div>
  <!-- Bottom Bar (Desktop Only) -->
   @if (!isVirtual) {
  <div class="header-bottom">
    <div class="header-bottom-left">
      <nav class="main-nav">
        @for (nav of headerNav; track $index) {
          <a class="nav-link" [routerLink]="[nav.url]" routerLinkActive="active">{{ nav.name| translate }}</a>
        }
      </nav>
    </div>
    <div class="header-bottom-right">
      @if (false) {
      <input
        type="date"
        [value]="selectedDate"
        (change)="onDateChange($event)"
        class="header-date-input"
        [attr.aria-label]="'select_date' | translate"
      />
      <button class="btn btn-fill-secondary" (click)="goToPreviousDate()" [attr.aria-label]="'previous_date' | translate">
        <img src="svg/chevron-left.svg" alt="{{ 'previous_date' | translate }}">
      </button>
      <button class="btn btn-fill-secondary" (click)="goToNextDate()" [attr.aria-label]="'next_date' | translate">
        <img src="svg/chevron-right.svg" alt="{{ 'next_date' | translate }}">
      </button>
      }

    </div>
  </div>

  }
  }
  <!-- Mobile Top Bar -->
  @else {
  <div class="header-top mobile">
    @if(!isVirtual) {
    <button class="nav-btn-toggle" data-bs-toggle="offcanvas" data-bs-target="#navMenuOffcanvas">
      <img src="svg/hamburger.svg" alt="Toggle navigation" height="32">
    </button>
    <a class="navbar-brand" [routerLink]="['/']">
      <img [src]="theme.logoUrl" alt="PMU Logo" height="52">
      <span class="slogan">{{ 'bet_to_win' | translate }}</span>
    </a>
    <div class="header-actions">
    
      @if (!isLoggedIn) {
        <button (click)="navigateToLogin()" type="button" class="btn-fill-primary" style="cursor: pointer;">{{ 'login' | translate }}</button>
        <button (click)="navigateToSignup()" type="button" class="btn-fill-secondary" style="cursor: pointer;">{{ 'signup' | translate }}</button>
      } @else {
        <ng-template [ngTemplateOutlet]="userActions"></ng-template>
      }
   
    </div> 
  } @else {
    <div class="user-manager">
        <span class="product-by">{{ (theme.userManagement?.poweredByText ?? 'a_product_of') | translate }}</span>
        <img (click)="gotoUrl()" [src]="theme.userManagement?.img" [alt]="theme.userManagement?.name" class="partner-logo" height="30">
      </div>
  }
  </div>
  }
  <!-- Language dropdown template (keep as is, just displaced) -->
  <ng-template #langSelect>
    <div class="dropdown lang-dropdown">
      <button class="btn dropdown-toggle btn-fill-accent" type="button" id="langDropdownBtn" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        {{(selectedLanguage | async )?.name}}
      </button>
      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="langDropdownBtn">
        @for (lang of languagesOffered; track $index) {
        <button
          class="dropdown-item" type="button"
          (click)="selectLanguage(lang.code)">
          {{lang.name | translate}}
          <img src="{{lang.image}}" alt="">
        </button>
      }
      </div>
    </div>
  </ng-template>

  <!-- User Actions Template - Responsive -->
  <ng-template #userActions>
    <!-- Main divider separating header content from user actions -->
    <div class="section-divider"></div>
    <div class="user-actions">

      @if (hasBonuses) {
        <div class="user-menu" routerLink="/profile/bonuses">
          <div class="bonus-icon">
            <img src="svg/{{theme.name}}/gift-wrapped.svg" alt="" class="icon">
            @if (bonusCount) {
              <span class="count">{{bonusCount | arNum}}</span>
            }
          </div>
          <span class="menu-title">{{ 'bonus' | translate }}</span>
        </div>
        <div class="section-divider"></div>
      }
        <!-- My Bets Section (hidden on mobile) -->
        <div class="user-menu" routerLink="/profile/bets">
          <img class="ticket-icon" src="svg/{{theme.name}}/ticket-perforated_primary.svg" />
          <span class="menu-title">{{ 'my_bets' | translate }}</span>
        </div>

        <!-- Divider between My Bets and User Profile -->
        <div class="section-divider"></div>

        <!-- User Balance and Profile Section -->
        <div class="user-profile"  [routerLink]="isMobile ? '/profile/menu' : '/profile/accounts'">
          <!-- User Balance (hidden on mobile) -->
          <div class="user-balance">
            <span class="balance-amount winning">{{ (userData?.balances?.winnings || 0) | currencyFormatter | arNum }}</span>
            <span class="balance-amount total">{{ (userData?.balances?.deposits || 0) | currencyFormatter | arNum }}</span>
          </div>

          <!-- User Profile Icon -->
          <img class="user-icon" src="svg/{{theme.name}}/person-rounded_secondary.svg" />
        </div>
    </div>
  </ng-template>
</div>

<div class="offcanvas offcanvas-start" #navMenuOffcanvas data-bs-scroll="true" tabindex="-1" id="navMenuOffcanvas" aria-labelledby="navMenuCanvasLabel">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title d-none">Menu</h5>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" (click)="hideCanvas()"></button>
  </div>
  <div class="offcanvas-body">
    <app-nav-menu (closeSideMenu)="hideCanvas()"></app-nav-menu>
  </div>
</div>
